import { useState, useEffect } from 'react';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = () => {
    try {
      const isAuth = localStorage.getItem('adminAuthenticated') === 'true';
      const loginTime = localStorage.getItem('adminLoginTime');
      
      if (isAuth && loginTime) {
        // Vérifier si la session n'a pas expiré (24 heures)
        const now = Date.now();
        const loginTimestamp = parseInt(loginTime);
        const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;
        
        if (now - loginTimestamp < TWENTY_FOUR_HOURS) {
          setIsAuthenticated(true);
        } else {
          // Session expirée
          logout();
        }
      }
    } catch (error) {
      console.error('Auth check error:', error);
    }
    
    setLoading(false);
  };

  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('adminAuthenticated');
    localStorage.removeItem('adminLoginTime');
    setIsAuthenticated(false);
  };

  return {
    isAuthenticated,
    loading,
    login,
    logout
  };
};